// import { HttpClient, SPHttpClient, MSGraphClientFactory, SPHttpClientResponse, } from "@microsoft/sp-http";

import { IDropdownOption } from "office-ui-fabric-react";
import { IAttachmentFileInfo  } from "@pnp/sp/presets/all";
import {  Web} from "sp-pnp-js";
import SettingService from "./SettingService";
import axios from 'axios';
import ContextService from "./ContextService";
import { getActivityData } from "../components/UtilityFunctions/CommonFunction";
export default class ActivityService{

  public static Activity: any; 
  public static BusinessUnit: any;
  public static Role:any;
  public static ID:any;
    public static Init(
        Activity: any, 
        BusinessUnit: any, 
        Role: any,
        ID:any,
    )
    { 
    this.Activity = Activity;
    this.BusinessUnit = BusinessUnit;
    this.Role = Role;
    this.ID = ID;
    }

    public static async getActivity(key,body,remark,fileNames,sendtoEmail,EmailFlag){

      const activityLogs=JSON.parse(localStorage.getItem("ActivityLogs")||"[]")
      let activityLogsData=[]
      if(activityLogs?.length==0||activityLogs==undefined||activityLogs==null){
        const activityData = await getActivityData();
        activityLogsData=[...activityData]
        localStorage.setItem("ActivityLogs", JSON.stringify(activityData));
      }else{
        activityLogsData=[...activityLogs]
      }
  
      
      return  this.PostActivityLog( body,activityLogsData?.filter(c=>c.Activity == key)[0]?.Description||"",key,remark,activityLogsData?.filter(c=>c.Activity == key)[0]?.EmailTemplate||"", fileNames, sendtoEmail,EmailFlag)
    }
    // public static getActivityByKey(){
    //   return this.Activity 
    // } Activity.getRoles()
    public static getRoles()
    { 
       return this.Role 
    }
    public static getBusinessUnit(){
      return this.BusinessUnit
    }
   
    public static getGeneralDataID(){
      return this.ID;
    }
    
    public static PostActivityLog(body:any,description:any,id:any,remark:any,EmailTemplate:any,fileNames:any,sendtoEmail:any , EmailFlag :any):any{
        const currDate = new Date();
        const token = localStorage.getItem("CurrentToken");
        const data = {};
        body.forEach(({ key, Value }) => {
        data[key] = Value;
      }); 
       const replaceEmailtemplate = EmailTemplate.replace(/\[(\w+)\]/g, (match, key) => {
        return data[key] || match;
      })
      const replaceAllEmailtemplate=replaceEmailtemplate.replaceAll("</p>", "<br>").replaceAll(
        "<p>",
        " "
      ).replaceAll("[Business_Unit] - ","").replaceAll("[Remarks]","")
      //.replaceAll("<p>", "").replaceAll("</p>", "");  
      const replacedStr = description.replace(/\[(\w+)\]/g, (match, key) => {
        return data[key] || match;
      });  
      let replacedString;
      if (!data['Business_Unit']||data['Business_Unit']==''||data['Business_Unit']==undefined) {
        replacedString = replacedStr.replace("[Business_Unit] - ", "");
      }
      else{
        replacedString=replacedStr;
      }
      const getUser:any = localStorage.getItem("CurrentUser");
      const CurrentUser=JSON.parse(getUser)
      let user=CurrentUser.currentUserName
      let guidsString = '';
      if(EmailFlag =="Yes" || EmailFlag =="yes"){
        let useremail=CurrentUser.currentUserEmail
        // let userinfo2=SettingService.GetclmMailboxid()
      let finalTemplate = {
        From: useremail,
        To: sendtoEmail?.To?.join(";"),
        CC: sendtoEmail?.Cc?.join(";"),
        Subject: replacedString,//replacedStr,
        Body: replaceAllEmailtemplate,
      };

        const url = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365ExternalMail')/items`;
        axios.post(url, finalTemplate, {
            headers: {
              Accept: "application/json;odata=nometadata",
              "Content-type": "application/json;odata=nometadata",
              "odata-version": "",
              Authorization: `Bearer ${token}`,
            },
          })
          .then((response) => {
            return response.data; // SharePoint's response JSON
          })
          .then(async (items: any) => {
          //   if (fileNames?.length>0) {
          //   let web = new Web(ContextService.GetUrl());
          //   let item = web.lists.getByTitle("CLM365ExternalMail").items.getById(items.Id);
          //   let attachments = await item.attachmentFiles.get();
          //   let attachmentNames = attachments.map((a) => a.FileName);
          //   await item.attachmentFiles.deleteMultiple(...attachmentNames);
          //   let fileInfos: IAttachmentFileInfo[] = [];
           
          //   for (let i = 0; i < fileNames.length; i++) {
          //     fileInfos.push({
          //       name: fileNames[i].File_Name,
          //       content: fileNames[i].File_Content,
          //     });
          //   }
      
          //   item.attachmentFiles.addMultiple(fileInfos);
          // }
        }).catch((c)=>{
          console.log(c)
        })
        
        // spForMail.setup({
        //   spfxContext: ContextService.GetFullContext(),
        // });
        // spForMail.utility
        //   .sendEmail({
        //     Body: replaceAllEmailtemplate,//replaceAllEmailtemplate,
        //     Subject: replacedStr,
        //     To: sendtoEmail,
        //     CC: [],
        //   })
         
        //   .catch((i) => {
        //     console.error(i);
        //   });
      }
      let allFileNames='';
      if(fileNames?.length>0){
        allFileNames=fileNames?.map((i)=>i.File_Guid).toString(); 
      }
      let temp1={  
        Activity: id,     
        Description : replacedString,//replacedStr,
        CreatedOn: currDate,  
        CreatedBy: user,
        CreatedByEmail:CurrentUser.currentUserEmail,
        Reasons:'',
        Remarks:encodeURIComponent(remark),
        Attachments: allFileNames != '' ?allFileNames:"",//fileNames,
        Approvers:body?.filter(i=>i?.key=="Assigned_To")?body?.filter(i=>i?.key=="Assigned_To")?.map(i=>i?.Value)?.flat():[],//body["Assigned_To"],
        Originator:body?.filter(i=>i?.key=="Originator")?body?.filter(i=>i?.key=="Originator")?.map(i=>i?.Value)?.flat():[],
        receivedUser:body?.filter(i=>i?.key=="receivedUser")?body?.filter(i=>i?.key=="receivedUser")?.map(i=>i?.Value)?.flat():[],
        Contract_Type:data["Contract_Type"]||""
      }   
        return temp1
      }
      
      public static GetRejectionRoles(){
        const rejectionRoles: IDropdownOption[] = [
          {key:"Business user", text: "Business user"},
          {key:"Legal User", text:"Legal User"},
          {key:"Legal head", text:"Legal head"},
      ]
      return rejectionRoles;
      }
      
}